import { apiRequest } from "./client";

export const integrationsApi = {
  getMercadoPago(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago`);
  },

  saveMercadoPago(projectId, payload) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  testMercadoPago(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago/test`, {
      method: "POST",
    });
  },

  disconnectMercadoPago(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/mercadopago`, {
      method: "DELETE",
    });
  },

  getModo(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/modo`);
  },

  saveModo(projectId, payload) {
    return apiRequest(`/projects/${projectId}/integrations/modo`, {
      method: "PUT",
      body: JSON.stringify(payload),
    });
  },

  testModo(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/modo/test`, {
      method: "POST",
    });
  },

  enableModo(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/modo/enable`, {
      method: "POST",
    });
  },

  disableModo(projectId) {
    return apiRequest(`/projects/${projectId}/integrations/modo/disable`, {
      method: "POST",
    });
  },

};
